import React from "react";
import Header from "@/components/jp/Header";
import Menu from "@/components/jp/Menu";
import Footer from "@/components/jp/Footer";
import FloatingButton from "@/components/jp/FloatingButton";
import ScrollToTopFab from "@/components/jp/ScrollToTopFab";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";

import SAbout from "@/public/static/images/opacity_about.png";
import SComNet from "@/public/static/images/opacity_company_network.png";
import SContact from "@/public/static/images/opacity_contact.png";

const breadcrumbs = [
  <Link key="1" href="/jp/">
    Home
  </Link>,
  <Typography key="2">Privacy Policy</Typography>,
];

function privacypolicy() {
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  Privacy Policy
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Disclaimer</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  <span className="fw-bold">ZENIYA (THAILAND) CO., LTD </span>
                  (referred to as ZENIYA below) understands that you care about
                  how your information is used and shared, and we appreciate
                  your trust that we will do so carefully and sensibly. This
                  notice describes our privacy policy. By visiting the ZENIYA
                  website, you are accepting the practices described in this
                  Privacy Notice.
                </p>
                <p className="mb-3">
                  What Personal Information About Customers Does ZENIYA Website
                  Gather?
                </p>
                <p className="mb-3">
                  The information we learn from customers helps us personalize
                  and continually improve your ZENIYA website experience. Here
                  are the types of information we gather:
                </p>
                <ul>
                  <li className="mb-3">
                    <span className="fw-bold">Information You Give Us : </span>
                    We receive and store any information you enter on our
                    website or give us in any other way. You can choose not to
                    provide certain information, but then you might not be able
                    to take advantage of our features. We use the information
                    that you provide for such purposes as responding to your
                    requests and communicating with you.
                  </li>
                  <li className="mb-3">
                    <span className="fw-bold">Automatic Information : </span> We
                    receive and store certain types of information whenever you
                    interact with us. For example, like many websites, we use
                    &quot;cookies,&quot; and we obtain certain types of
                    information when your web browser accesses the ZENIYA
                    website or advertisements and other content served by or on
                    behalf of ZENIYA on other websites.
                  </li>
                  <li className="mb-3">
                    <span className="fw-bold">Email Communications : </span>To
                    help us make email more useful and interesting, we often
                    receive a confirmation when you open an email from ZENIYA if
                    your computer supports such capabilities. We also compare
                    our customer list to lists received from other companies, in
                    an effort to avoid sending unnecessary messages to our
                    customers.
                  </li>
                  <li className="mb-3">
                    <span className="fw-bold">
                      Information from Other Sources :{" "}
                    </span>
                    We might receive information about you from other sources
                    and add it to our account information.{" "}
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">What About Cookies?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  Cookies are unique identifiers that we transfer to your device
                  to enable our system to recognize your device and to provide
                  feature such as purchasing, personalized language on websites.
                  The Help feature on most browsers will tell you how to prevent
                  your browser from accepting new cookies, how to have the
                  browser notify you when you receive a new cookie, or how to
                  disable cookies altogether. Additionally, you can disable or
                  delete similar data used by browser add-ons, such as Flash
                  cookies, by changing the add-on&apos;s settings or visiting
                  the websites of its manufacturer. Because cookies allow you to
                  take advantage of some of ITT website essential features, we
                  recommend that you leave them turned on. For instance, if you
                  block or otherwise reject our cookies, you will not be able to
                  add items again, or use any ITT website products and services
                  that require you to Sign in.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">What About Cookies?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  Information about our customer is an important part of our
                  business, and we are not in the business of selling it to
                  others. We share customer information only as described below
                  and with subsidiaries of ZENIYA to control that either are
                  subject to this Privacy Policy or follow practices at least as
                  protective as those described in this Privacy Policy.
                </p>

                <ul>
                  <li className="mb-3">
                    <span className="fw-bold">Promotional Offers : </span>
                    Sometimes we send offer to selected group of ZENIYA’s
                    customer on behalf of other businesses. When we do this, we
                    do not give that business your name and address.
                  </li>
                  <li className="mb-3">
                    <span className="fw-bold">
                      Protection of ZENIYA website :
                    </span>
                    We We release account and other personal information when we
                    believe release is appropriate to comply with the law;
                    enforce or apply our Term & Condition and other agreements;
                    or protect the rights, property, or safety of ZENIYA website
                    and our users. This includes exchanging information with
                    other company and organization for fraud protection and
                    credit risk reduction.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">How Secure Is Information About Me?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <ul>
                  <li className="mb-3">
                    We work to protect the security of your information during
                    transmission by using Secure Sockets Layer (SSL) software,
                    which encrypts information you input.
                  </li>
                  <li className="mb-3">
                    It is important for you to protect against unauthorized
                    access to your password (if any) and to your computer. Be
                    sure to sign off when finished using a shared computer.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Which Information Can I Access?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  ZENIYA website gives you access to a broad range of
                  information about your account (if any) and your interaction
                  with ZENIYA for the limited purpose of viewing, download and
                  in certain cases, updating information.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">What Choices Do I Have?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  Information about our customer is an important part of our
                  business, and we are not in the business of selling it to
                  others. We share customer information only as described below
                  and with subsidiaries of ZENIYA to control that either are
                  subject to this Privacy Policy or follow practices at least as
                  protective as those described in this Privacy Policy.
                </p>

                <ul>
                  <li className="mb-3">
                    As discussed above, you can always choose not to provide
                    information, even though it might be needed to take
                    advantage of such ZENIYA website features as News & Update,
                    communication with ZENIYA etc.
                  </li>
                  <li className="mb-3">
                    The Help feature on most browsers will tell you how to
                    prevent your browser from accepting new cookies, how to have
                    the browser notify you when you receive a new cookie, or how
                    to disable cookies altogether. Additionally, you can disable
                    or delete similar data used by browser add-ons, such as
                    Flash cookies, by changing the add-on&apos;s settings or
                    visiting the websites of its 5manufacturer. Because cookies
                    allow you to take advantage of some of ZENIYA website
                    essential features, we recommend that you leave them turned
                    on. For instance, if you block or otherwise reject our
                    cookies, you will not be able to use any ZENIYA website
                    products and services that require you to Sign in.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">
                  Are Children Allowed to Access ZENIYA website?
                </h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  ZENIYA website does not provide information for children.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">
                  Conditions of Use, Notice, and Revision
                </h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  If you choose to visit ZENIYA website, your visit and any
                  dispute over privacy is subject to this Notice and our Term
                  and Condition, including limitation on damage, resolution of
                  dispute, and application of the law of Thailand. If you have
                  any concern about privacy at ZENIYA website, please contact us
                  with a thorough description, and we will try to resolve it.
                  Our business changes constantly, and our Privacy Policy and
                  the Term & Condition will change also. We may e-mail periodic
                  reminder of our notice and condition, but you should check our
                  websites frequently to see recent changes. Unless stated
                  otherwise, our current Privacy Notice applies to all
                  information that we have about you and your account (if any).
                  We stand behind the promises we make, however, and will never
                  materially change our policies and practices to make them less
                  protective of customer information collected in the past
                  without the consent of affected customer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">会社概要</h1>
                </div>
              </div>
            </Link>
            <Link href="/companynetwork">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SComNet}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">関連会社紹介</h1>
                </div>
              </div>
            </Link>
            <Link href="/contactus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SContact}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">お問い合わせ</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>

      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export default privacypolicy;
